import {SamplerPanel} from "./sampler-panel";
/**
 * A static nosie generator that uses a canvas to generate static noise, and retrieves images from the
 * provided sampler to flash ghost over the static.
 */
export class StaticNoise
{
	private FRAMES = 20;

	private frames : Array<ImageData> = [];
	private frame : ImageData;
	private ctx : CanvasRenderingContext2D;

	private cancelled = false;
	private turn = 0;
	private frameSize;

	private wh : number;
	private hh : number;

	private $ghost;

	constructor(private canvas : HTMLCanvasElement, private sampler : SamplerPanel)
	{
		this.ctx = canvas.getContext("2d");
		this.ctx.fillStyle = "rgba(255, 255, 255, 0.025)";

		this.frameSize = canvas.width * canvas.height; // Quarter frame, 4 byte per pixel
		this.wh = this.canvas.width / 2;
		this.hh = this.canvas.height / 2;

		this.frame = this.ctx.createImageData(this.wh, this.hh);

		this.$ghost = $("<div class=\"ghost\" />")
			.insertAfter($(this.canvas));
	}

	public start()
	{
		this.cancelled = false;
		this.drawFrame();
	}

	public cancel()
	{
		this.cancelled = true;
	}

	private drawNoise(frame : ImageData) : ImageData
	{
		var data = frame.data;

		for(var x = 0; x < this.frameSize; x+=4)
		{
			var c = Math.floor(Math.random() * 2) * 30;
			data[x] = c;
			data[x + 1] = c;
			data[x + 2] = c;
			data[x + 3] = 255;
		}

		return frame;
	}

	private ghost = 0;

	private drawFrame()
	{
		this.turn++;

		if (this.turn % 2 === 0)
		{
			var noise = this.drawNoise(this.frame);
			this.ctx.putImageData(noise, 0,0);
			this.ctx.putImageData(noise, this.wh, 0);
			this.ctx.putImageData(noise, 0, this.hh);
			this.ctx.putImageData(noise, this.wh, this.hh);

			this.ctx.fillRect(0, (this.turn) % (this.canvas.height + 300) - 50, this.canvas.width, 50);

			if ((this.sampler && this.sampler.bigList && this.sampler.bigList.length))
			{
				if (this.ghost) {
					this.ghost--;
					this.$ghost.css("opacity", Math.random()/4);

					if (this.ghost == 1) this.$ghost.removeClass("sxc-visible");
				} else {

					if (this.turn < 500) {
						var show = Math.floor(Math.random() * 500) === 0
					} else {
						var show = Math.floor(Math.random() * 200) === 0
					}

					if (show) {
						this.$ghost.addClass("sxc-visible");
						this.ghost = Math.floor(Math.random() * 7) + 3;

						var idx = Math.floor(Math.random() * this.sampler.bigList.length);
						var pic = this.sampler.bigList[idx].publicData.profilePic;

					// 	let pic = "http://i.ytimg.com/vi/osoJdIK2rNA/maxresdefault.jpg";
						this.$ghost.css("background-image", "url(" + pic + ")");
					}
				}
			}
		}


		if (!this.cancelled) requestAnimationFrame(this.drawFrame.bind(this));
	}
}
